module.exports = __webpack_public_path__ + "assets/img/ja-839a11c3.png";